import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Box, Typography, Button, TextField } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import apiHelper from "../../../../util/ApiHelper";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const useStylesAll = makeStyles((theme) => ({
  root: {
    margin: 0,
    marginBottom: 20,
    minWidth: "100%",
  },
  last: {
    margin: 0,
  },
}));

const defaultValues = {
  type: "product",
  localizations: {
    en: {
      name: "",
    },
    tc: {
      name: "",
    },
  },
  status: true,
};

const schema = yup.object().shape({
  localizations: yup.object().shape({
    en: yup.object().shape({
      name: yup.string().required("Name (English)"),
    }),
    tc: yup.object().shape({
      name: yup.string().required("Name (Traditional Chinese)"),
    }),
  }),
});

const ProductTagForm = ({ formTitle,  ...props }) => {
  const { id } = useParams();
  const history = useHistory();
  const classes = useStylesAll();

  const { control, handleSubmit, reset } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  React.useEffect(() => {
    if (id) {
      apiHelper.hkiff
        .getProductTagById(id)
        .then((response) => {
          reset(response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, []);

  const updateProductTag = async (data) => {
    try {
      const result = await apiHelper.hkiff.updateProductTagById(id, {
        ...data,
        updateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      });
      console.log(result.data);
      toast.dark("Your changes is saved.");
      history.push("/hkiff/eshop/product-tag");
    } catch (err) {
      console.log(err);
    }
  };

  const createProductTag = async (data) => {
    try {
      console.log(data);
      await apiHelper.hkiff.postProductTag(data);
      toast.dark("Product Tag created.");
      history.push("/hkiff/eshop/product-tag");
    } catch (err) {
      console.log(err);
    }
  };

  const onSubmit = (data) => {
    const sendProductTag = () => {
      const req = data;
      if (id) {
        updateProductTag(req);
      } else {
        createProductTag(req);
      }
    };
    sendProductTag();
  };

  return (
    <>
      <Box fontWeight={900} fontSize={13} mb={2} width="100%">
        <Typography variant="p">{formTitle}</Typography>
      </Box>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <fieldset className="fieldset">
          <Box width="100%">
            <Controller
              control={control}
              name="localizations.en.name"
              defaultValue=""
              render={({ field, fieldState: { error } }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (English)"
                    variant="outlined"
                    {...field}
                    fullWidth
                    error={!!error}
                    helperText={
                      error
                        ? error.message
                        : "The name is how it appears on your site."
                    }
                  />
                );
              }}
            />
            <Controller
              control={control}
              name="localizations.tc.name"
              defaultValue=""
              render={({ field, fieldState: { error } }) => {
                return (
                  <TextField
                    id="outlined-basic"
                    className={classes.root}
                    label="Name (Traditional Chinese)"
                    variant="outlined"
                    {...field}
                    fullWidth
                    error={!!error}
                    helperText={
                      error
                        ? error.message
                        : "The name is how it appears on your site."
                    }
                  />
                );
              }}
            />
            <Box width="25%">
              <Controller
                defaultValue={true}
                name="status"
                control={control}
                render={({
                  field: { value, onChange, ...rest },
                  fieldState: { error },
                }) => (
                  <ToggleButtonGroup
                    {...rest}
                    value={value}
                    onChange={(event, newFormats) => {
                      onChange(newFormats);
                    }}
                    exclusive
                    aria-label="status"
                    size="large"
                    fullWidth
                  >
                    <ToggleButton
                      className={classes.root}
                      value={true}
                      aria-label="active"
                    >
                      Active
                    </ToggleButton>
                    <ToggleButton
                      className={classes.root}
                      value={false}
                      aria-label="inactive"
                    >
                      Inactive
                    </ToggleButton>
                  </ToggleButtonGroup>
                )}
              />
            </Box>
            <Box display="flex" alignItems="flex-end" alignContent="flex-end">
              <Box>
                <Button
                  className={classes.last}
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                >
                  {props.submitBtnTxt}
                </Button>
              </Box>
            </Box>
          </Box>
        </fieldset>
      </form>
    </>
  );
};

export default ProductTagForm;
